// extracted by mini-css-extract-plugin
export var buttonLink = "SecondaryCard-module--buttonLink--f5584";
export var contentContainer = "SecondaryCard-module--contentContainer--37d02";
export var heading = "SecondaryCard-module--heading--93f74";
export var horizontal = "SecondaryCard-module--horizontal--2776d";
export var image = "SecondaryCard-module--image--e4856";
export var link = "SecondaryCard-module--link--2829f";
export var linkText = "SecondaryCard-module--linkText--bf8ec";
export var secondary = "SecondaryCard-module--secondary--86448";
export var secondaryLink = "SecondaryCard-module--secondaryLink--c9621";
export var subheading = "SecondaryCard-module--subheading--6e04b";